import { Directive, HostListener, Input, ElementRef } from '@angular/core';

@Directive({
    selector: 'img[fallbackImage]',
    exportAs: 'fallbackImage',
    standalone: false
})
export class FallbackImageDirective {

  @Input() fallbackImage: string = 'assets/class/sm-0.svg';

  constructor(private el: ElementRef<HTMLImageElement>) {
    
  }

  @HostListener('error')
  onError() {
    const element = this.el.nativeElement;
    if (element.src !== this.fallbackImage) {
      element.src = this.fallbackImage;
    }
  }
}
  